/* eslint-disable */
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getFirestore} from 'firebase/firestore'
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCz2OKKfpNz3BfxO4uD6w2pW4uCVH-1z1A",
  authDomain: "easyadim.firebaseapp.com",
  projectId: "easyadim",
  storageBucket: "easyadim.appspot.com",
  messagingSenderId: "238412711578",
  appId: "1:238412711578:web:75b2e569ab23f1722c4123",
  measurementId: "G-T0Q828RB8B"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const storage = getStorage(app)
export const db = getFirestore()